var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telephone-call",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16434",
    "data-name": "Path 16434",
    d: "M19.61,15.731c-.562-.471-3.857-2.558-4.4-2.462-.257.046-.454.265-.98.893a7.513,7.513,0,0,1-.8.866,6.915,6.915,0,0,1-1.526-.566A9.45,9.45,0,0,1,7.538,10.1a6.915,6.915,0,0,1-.566-1.526,7.513,7.513,0,0,1,.866-.8c.627-.526.847-.722.893-.98.1-.549-1.993-3.843-2.462-4.4-.2-.233-.375-.389-.6-.389C5,2,2,5.711,2,6.191c0,.039.064,3.9,4.943,8.866C11.906,19.936,15.769,20,15.809,20,16.289,20,20,17,20,16.336c0-.229-.156-.408-.39-.6Z",
    transform: "translate(0 0)",
    fill: "#003a6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16435",
    "data-name": "Path 16435",
    d: "M20.857,12.143h1.286A5.149,5.149,0,0,0,17,7V8.286a3.861,3.861,0,0,1,3.857,3.857Z",
    transform: "translate(-5.357 -1.786)",
    fill: "#003a6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16436",
    "data-name": "Path 16436",
    d: "M24.071,10.357h1.286A8.367,8.367,0,0,0,17,2V3.286A7.08,7.08,0,0,1,24.071,10.357Z",
    transform: "translate(-5.357)",
    fill: "#003a6f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneCall);
export default __webpack_public_path__ + "static/media/telephone-call.2dde7e7ff85cecdada9cdfc23acc230f.svg";
export { ForwardRef as ReactComponent };